<template>
  <div class="max-w-8xl mx-auto p-6">
    <!-- Grid Layout for larger screens, List for mobile -->
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
      <div
v-for="friend in friends" :key="friend.id"
        class="bg-white border border-gray-200 rounded-xl shadow-sm hover:shadow-md transition-all duration-200 overflow-hidden"
>
        <FriendItem :friend="friend"></FriendItem>
      </div>
    </div>

    <!-- Empty State -->
    <div v-if="friends.length === 0" class="text-center py-16">
      <div class="text-gray-400 text-6xl mb-4">👥</div>
      <h3 class="text-lg font-medium text-gray-600 mb-2">No friends or family yet</h3>
      <p class="text-gray-500">Get started by adding a friend or family member using the button above</p>
    </div>
  </div>
</template>

<script>
import { API } from 'aws-amplify';

import { onUpdateFriend, onCreateFriend, onCreateGiftFriend, onDeleteFriend, onDeleteGiftFriend } from "../graphql/subscriptions";

import FriendItem from "@/components/FriendItem.vue";

export default {
  name: 'FriendList',
  data() {
    return {
      form: {},
      friendCreateSub: null,
      friendUpdateSub: null,
      friendDeleteSub: null,
      giftFriendCreateSub: null,
      giftFriendDeleteSub: null,

    }
  },
  components: {
    FriendItem
  },
  computed: {
    friends() {
      return this.$store.state.friendMap;
    },
  },
  created() {
    this.getFriends();
    if (this.$store.state.user.loggedIn) {
      this.subscribe();
    }
  },
  mounted() {
  },
  unmounted() {
    this.friendCreateSub.unsubscribe();
    this.friendUpdateSub.unsubscribe();
    this.friendDeleteSub.unsubscribe();
    this.giftFriendCreateSub.unsubscribe();
    this.giftFriendDeleteSub.unsubscribe();
  },

  methods: {
    async getFriends() {
      const query = `query MyQuery {
  listFriends {
    items {
      id
      name
      email
      birthday
      reminder
      anniversary
      anniversaryReminder
      updatedAt
      GiftLink {
        items {
          id
          purchased
          createdAt
          updatedAt
          gift {
            name
            id
            price
            url
            image
            description
          }
        }
      }
    }
  }
}`
      let friends = await API.graphql({
        query: query
      });
      var sortedFriends = friends.data.listFriends.items.sort(
        function (a, b) {
          let nameA = a.name.toUpperCase();
          let nameB = b.name.toUpperCase();

          if (nameA < nameB) {
            return -1;
          }

          if (nameA > nameB) {
            return 1;
          }
        }
      );
      this.$store.dispatch("updateFriends", sortedFriends);
    },

    subscribe() {
      this.friendCreateSub = API.graphql({
        query: onCreateFriend,
        variables: { owner: this.$store.state.user.data.userid },
      }).subscribe({
        next: (eventData) => {
          let friend = eventData.value.data.onCreateFriend;
          this.$store.dispatch("addFriend", friend);
        },
      });

      this.giftFriendCreateSub = API.graphql({
        query: onCreateGiftFriend,
        variables: { owner: this.$store.state.user.data.userid },
      }).subscribe({
        next: (eventData) => {
          this.getFriends()
        },
      });

      this.friendUpdateSub = API.graphql({
        query: onUpdateFriend,
        variables: { owner: this.$store.state.user.data.userid },
      }).subscribe({
        next: (eventData) => {
          let friend = eventData.value.data.onUpdateFriend;

          this.$store.dispatch("updateFriend", friend);
        },
      });

      this.friendDeleteSub = API.graphql({
        query: onDeleteFriend,
        variables: { owner: this.$store.state.user.data.userid },
      }).subscribe({
        next: (eventData) => {
          this.getFriends()
        },
      });

      this.giftFriendDeleteSub = API.graphql({
        query: onDeleteGiftFriend,
        variables: { owner: this.$store.state.user.data.userid },
      }).subscribe({
        next: (eventData) => {
          this.getFriends()
        },
      });

    },
  }
}
</script>
